require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-e-grdvbl-5-q-s-8-rfk-cl-67-h-zj.json") })
        }
      }, "path---news-e-grdvbl-5-q-s-8-rfk-cl-67-h-zj");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-e-grdvbl-5-q-s-8-rfk-cl-67-h-zj!./.cache/json/news-e-grdvbl-5-q-s-8-rfk-cl-67-h-zj.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-e-grdvbl-5-q-s-8-rfk-cl-67-h-zj!./.cache/json/news-e-grdvbl-5-q-s-8-rfk-cl-67-h-zj.json
// module chunks = 231608221292675